module.exports = __webpack_public_path__ + "img/3.e0931b6a.png";